module.exports = __webpack_public_path__ + "static/media/Check.856e2d9c.svg";